import { Box } from "@mui/material";
import React, { PropsWithChildren } from "react";

/**
 * Box para criar Header fixos no topo.
 * @param props
 */
export const MprcBoxHeader: React.FC<PropsWithChildren> = (props) => {
    return (
        <Box sx={(theme) => ({ position: "sticky", zIndex: 2, top: theme.spacing(-2), mb: theme.spacing(2) })}>
            {props.children}
        </Box>
    );
};
